<template>
<v-dialog v-model="dialog" persistent width="500px">
  <v-card>
    <v-card-title class="warning headline" style="font-weight:bold; color:white">Confirm Delete</v-card-title>
    <v-card-text>Are you sure you want to remove {{ oms }} from the invoice {{ nr }} ?</v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn class="warning mx-2" small @click="rmIpfr">Yes</v-btn>
      <v-btn color="success"  small @click="dialog=false">No</v-btn>
    </v-card-actions>
  </v-card>
</v-dialog>
</template>

<script>
export default {
  data() { 
    return {
      dialog: false,
      ipfr_encrid: null,
      oms: '',
      nr: '',
      ipfr: {}
    }
  },
  methods: {
    open(ipfr_encrid, oms, nr) {
      this.ipfr_encrid = ipfr_encrid;
      this.oms = oms; 
      this.nr = nr;
      this.dialog = true;
      // this.$axios
      //   .post("ares/json/ares/task/inpt/ipfc/ipfr/getIpfr.p", {
      //     header: {
      //       token: this.$session.get("ARES"),
      //       clientSessionId: this.$session.id(),
      //       request: "getIpfr"
      //     },
      //     getIpfr: {
      //       ipfr_encrid: ipfr_encrid
      //     }
      //   })
      //   .then(res => {
      //     if (res.data.error) {
      //       console.log(res.data.error);
      //     } else {
      //       this.ipfr = res.data.getIpfr;
      //     }
      //   })
      //   .finally(() => {
      //     this.loading = false;
      //   });
    },
    rmIpfr() { 
      // this.$axios
      //   .post("ares/json/ares/task/inpt/ipfc/ipfr/rmIpfr.p", {
      //     header: {
      //       token: this.$session.get("ARES"),
      //       clientSessionId: this.$session.id(),
      //       request: "rmIpfr"
      //     },
      //     rmIpfr: {
      //       ipfr_encrid: this.ipfr.ipfr_encrid
      //     }
      //   })
      //   .then(res => {
      //     if (res.data.error) {
      //       console.log(res.data.error);
      //     }  else { 
      //        if (res.data.rmIpfr.color == "success") { 
      //           setTimeout(() => { this.$router.reload('/task/inpt/ipfc/onIpfcTmp/' + res.data.rmIpfr.ipfc_encrid);  }, 2000);      
      //        }   
      //        this.$store.dispatch('setSnackbar', {
      //         showing: true,
      //         text: res.data.rmIpfr.text,
      //         color: res.data.rmIpfr.color
      //       });
            
      //       this.dialog = false;
      //     }
      //   })
    },
  }
}
</script>

